import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvService } from 'src/app/_services/env.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect-url',
  templateUrl: './redirect-url.component.html',
  styleUrls: ['./redirect-url.component.scss'],
})
export class RedirectUrlComponent implements OnInit {

  constructor(private route: ActivatedRoute, private env:EnvService) {}

  ngOnInit() {
    // Get the current URL
    const currentUrl = this.route.snapshot.url.join('/');

    if (currentUrl === 'admin') {
      window.location.href = this.env.url.admin_url;
    } else {
      window.location.href = 'https://sidumas.badungkab.go.id';
    }
  }

}
